import { render, staticRenderFns } from "./topicManagement.vue?vue&type=template&id=7983f1bc&scoped=true"
import script from "./topicManagement.vue?vue&type=script&lang=js"
export * from "./topicManagement.vue?vue&type=script&lang=js"
import style0 from "./topicManagement.vue?vue&type=style&index=0&id=7983f1bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7983f1bc",
  null
  
)

export default component.exports